export interface IUiLoadingState {
  isFetchingResources?: boolean;
  isProcessing?: boolean;
  isInitialLoading?: boolean;
  areActionsDisabled?: boolean;
}
